export default function () {
  if (document.getElementById('page-brand')) {
    import(/* webpackChunkName: "page-brand" */ '@organisms/page-brand/map/main');
  }
}
